import { render, staticRenderFns } from "./buttonV2.vue?vue&type=template&id=6535ee96&scoped=true"
import script from "./buttonV2.vue?vue&type=script&lang=js"
export * from "./buttonV2.vue?vue&type=script&lang=js"
import style0 from "./buttonV2.vue?vue&type=style&index=0&id=6535ee96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6535ee96",
  null
  
)

export default component.exports